import QuotationService from '_services/rest/modules/quotation';
import { GROUP, PROJECT_DIMENSIONS } from '_modules/quotation/components/QuotationModel';
import { cloneDeep } from '_utils';

export default {
  state: {
    status: null,
    drives: null,
    modelList: null,
    quotation: null,
    priorities: null,
    typeOptions: null,
    classOptions: null,
    templateList: null,
    quotationList: null,
    productTypeOptions: null,
    paymentTypeOptions: null,
  },
  mutations: {
    setDrives(state, response) {
      state.drives = response || [];
    },
    setQuotation(state, response) {
      state.quotation = response;
      if (state.quotation.groups.length === 0) {
        state.quotation.groups = [cloneDeep(GROUP)];
      }
      state.quotation.groups = response.groups.map(group => {
        group = { ...cloneDeep(GROUP), ...group };
        if (group.project_dimensions == null) {
          group.project_dimensions = cloneDeep(PROJECT_DIMENSIONS);
        }
        return group;
      });
    },
    setModelList(state, response) {
      state.modelList = response;
    },
    setQuotationList(state, response) {
      state.quotationList = response;
    },
    setTemplateList(state, response) {
      state.templateList = response;
    },
    setProductTypeOptions(state, response) {
      state.productTypeOptions = response;
    },
    setPaymentTypeOptions(state, response) {
      state.paymentTypeOptions = response;
    },
    setPriorities(state, response) {
      state.priorities = response;
    },
    setStatus(state, response) {
      state.status = response;
    },
    setTypeOptions(state, response) {
      state.typeOptions = response;
    },
    setClassOptions(state, response) {
      state.classOptions = response;
    },
  },
  actions: {
    getQuotation({ commit }, params) {
      return QuotationService.getQuotationById(params)
        .then(response => {
          commit('setQuotation', response);
          return response;
        });
    },
    getDrives({ commit }) {
      return QuotationService.getDrivesOptions()
        .then(response => {
          commit('setDrives', response);
        });
    },
    getModelList({ commit }, params) {
      return QuotationService.getModelList(params)
        .then(response => {
          commit('setModelList', response);
        });
    },
    getQuotationList({ commit }, params) {
      return QuotationService.getList(params)
        .then(response => {
          commit('setQuotationList', response);
        });
    },
    getTypeOptions({ commit }) {
      return QuotationService.getTypeOptions()
        .then(response => {
          commit('setTypeOptions', response);
        });
    },
    getClassOptions({ commit }) {
      return QuotationService.getClassOptions()
        .then(response => {
          commit('setClassOptions', response);
        });
    },
    getStatus({ commit }) {
      return QuotationService.getStatus()
        .then(response => {
          commit('setStatus', response);
        });
    },
    getTemplates({ commit }, params) {
      return QuotationService.getTemplates(params)
        .then(response => {
          commit('setTemplateList', response);
        });
    },
    getTemplateById({ commit }, id) {
      return QuotationService.getTemplateById(id)
        .then(response => {
          commit('setTemplate', response);
        });
    },
    getProductTypeOptions({ commit }) {
      return QuotationService.getProductTypeOptions()
        .then(response => {
          commit('setProductTypeOptions', response);
        });
    },
    getPaymentTypeOptions({ commit }) {
      return QuotationService.getPaymentTypeOptions()
        .then(response => {
          commit('setPaymentTypeOptions', response);
        });
    },
    getPriorities({ commit }) {
      return QuotationService.getPriorities()
        .then(response => {
          commit('setPriorities', response);
        });
    },
  },
};
